import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
/**
 * è¿è¡æ¶éç½®
 *
 */
export abstract class DynamicFormRuntimeConfig {
  /**
   * æå¡å°å
   *
   */
  abstract serviceUrl: string;
}
